import { core, safeToNumber } from '@tock/coretypes';
import { noop } from 'lodash';
import AppConstants from 'constants/AppConstants';
import consumerProto from 'utils/consumerProto';

const { FreeConsumerRescheduleRequest, PaidConsumerRescheduleRequest } = consumerProto;

export function setRescheduleInfo(purchase: core.PastPurchase, token?: string): BaseTockAction {
  return {
    type: AppConstants.RESCHEDULE_PURCHASE_UPDATE,
    payload: {
      purchase,
      token,
    },
  };
}

export function reschedule(
  purchase: core.PastPurchase,
  lockedTicketSubset: core.TicketSubset,
  targetDateTime: string,
  token?: string
): ApiAction {
  const request = FreeConsumerRescheduleRequest.fromObject({
    purchaseId: purchase.id,
    lockedTicketSubsetId: lockedTicketSubset.id,
    targetDateTime,
    token,
  });
  return {
    TockApi: {
      putProto: '/purchase/reschedule',
      request,
      type: AppConstants.RESCHEDULE,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      scope: { businessId: safeToNumber(purchase.business!.id) },
    },
  };
}

export function reschedulePaid(
  previousPurchase: core.PastPurchase,
  purchaseOrder: core.IPurchaseOrder
): ApiAction {
  const request = PaidConsumerRescheduleRequest.fromObject({
    purchaseId: safeToNumber(previousPurchase.id), // sending original purchase to make sure its part of the chain
    purchaseOrder,
  });
  return {
    TockApi: {
      putProto: '/purchase/reschedule/paid',
      request,
      type: AppConstants.RESCHEDULE,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      scope: { businessId: safeToNumber(previousPurchase.business!.id) },
      onError: noop, //Checkout Flow handles errors, see CompletePurchase#handleError.
    },
  };
}

export function clear() {
  return {
    type: AppConstants.RESCHEDULE_CLEAR,
  };
}
